module.exports = __webpack_public_path__ + "img/02_zhTc.a5376fbd.png";